export default "__VITE_ASSET__MJpAEx$C__"